import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import projectList from "./const/projectList";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>


          {
            projectList.map((E) => {
              return <Col md={4} className="project-card">
                <ProjectCard
                  imgPath={E.imgPath}
                  isBlog={E.isBlog}
                  title={E.title}
                  description={E.description}
                  ghLink={E.ghLink}
                  demoLink={E.demoLink}
                />
              </Col>
            })
          }






        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
